import script from "./videoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./videoSection.vue?vue&type=script&setup=true&lang=js"

import "./videoSection.vue?vue&type=style&index=0&id=7c8c6978&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8c6978"]])

export default __exports__